import { Ref, forwardRef } from "react"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../../shared/components/forms/SchemaFormik"
import * as yup from "yup"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"
import { CreateOrEditProductNumber, ProductNumberHistory } from "../productNumbersTypes"
import { FormProductGroupNumberContent } from "./FormProductGroupNumberContent"

type CreateOrEditProductGroupNumberFormProps = Readonly<{
    initialValues?: CreateOrEditProductNumber
    history?: ProductNumberHistory
    onSubmit: (formData: CreateOrEditProductNumber) => void
}>

const defaultInitialValues: CreateOrEditProductNumber = {
    name: "",
    code: "",
    description: "",
    isActive: true,
}

type FormikRef = Ref<FormikProps<CreateOrEditProductNumber>>

export const CreateUpdateProductGroupNumberForm = forwardRef(
    ({ initialValues, onSubmit, history }: CreateOrEditProductGroupNumberFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()

        const validationSchema = yup.object({
            code: yup.string().required(l10n.getString("supplier-admin-erp-product-group-numbers-required-code")),
            name: yup.string().required(l10n.getString("supplier-admin-erp-product-group-numbers-required-name")),
            description: yup.string(),
            isActive: yup.boolean(),
        })

        function handleSubmit(values: CreateOrEditProductNumber) {
            onSubmit(values)
        }

        return (
            <Formik<CreateOrEditProductNumber>
                enableReinitialize
                initialValues={initialValues ? initialValues : defaultInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <FormProductGroupNumberContent history={history} />
                </Form>
            </Formik>
        )
    },
)
